
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/naudojimo-taisykles",
      function () {
        return require("private-next-pages/lt/sub/naudojimo-taisykles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/naudojimo-taisykles"])
      });
    }
  